(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whynot-fit-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var dialog;
    var wrap;

    var closeBtn = e.target.closest('[data-wn-close]');
    if (closeBtn) {
      dialog = closeBtn.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    if (e.target.classList && e.target.classList.contains('wn-fit__dialog')) {
      e.target.close();
      return;
    }

    var btn = e.target.closest('[data-wn-size-link]');
    if (!btn) return;

    wrap = btn.closest('.wn-fit');
    dialog = wrap && wrap.querySelector('dialog');
    if (!dialog) return;

    var norm = function (s) {
      return (s || '').toLowerCase().replace(/\s+/g, ' ').trim();
    };

    if (dialog.getAttribute('data-wn-ready') !== 'true') {
      var needle = norm(wrap.getAttribute('data-wn-target')) || 'size chart';
      var summaries = document.querySelectorAll('details > summary');
      var source = null;

      for (var i = 0; i < summaries.length; i++) {
        if (norm(summaries[i].textContent).indexOf(needle) !== -1) {
          source = summaries[i].parentElement;
          break;
        }
      }

      if (source) {
        var body = dialog.querySelector('[data-wn-body]');
        var html = '';
        Array.prototype.forEach.call(source.children, function (child) {
          if (child.tagName !== 'SUMMARY') html += child.innerHTML;
        });
        if (html.trim()) {
          body.innerHTML = html;
          dialog.setAttribute('data-wn-ready', 'true');
        }
      }
    }

    if (dialog.getAttribute('data-wn-ready') === 'true') {
      dialog.showModal();
    } else {
      var toggles = document.querySelectorAll('[aria-expanded]');
      var nd = norm(wrap.getAttribute('data-wn-target')) || 'size chart';
      for (var j = 0; j < toggles.length; j++) {
        if (norm(toggles[j].textContent).indexOf(nd) !== -1) {
          if (toggles[j].getAttribute('aria-expanded') === 'false') toggles[j].click();
          toggles[j].scrollIntoView({ behavior: 'smooth', block: 'center' });
          break;
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
